import { useMemo } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { type Title, useTitles } from "./useTitles";

const DEFAULT_HUB = "esports";

export type Hub = Omit<Queries.ContentfulHub, "titles"> & {
  pathPrefix: string;
  titles: Title[];
};

const useHubs = (): Hub[] => {
  const titles = useTitles();

  const { allContentfulHub } = useStaticQuery(graphql`
    {
      allContentfulHub(
        filter: { slug: { in: ["sports", "esports", "racing"] } }
      ) {
        nodes {
          name
          slug
          titles {
            slug
          }
          banners {
            ...Banner
          }
          bettingHeaderFaq {
            ...Faq
          }
        }
      }
    }
  `);

  return useMemo(() => {
    return allContentfulHub.nodes.map((hub: Queries.ContentfulHub) => {
      const mappedTitles = hub.titles
        ? (hub.titles
            .map((title) => {
              if (!title?.slug) {
                return;
              }
              return titles[title.slug];
            })
            .filter(Boolean) as Title[])
        : [];

      return {
        ...hub,
        pathPrefix: hub.slug === DEFAULT_HUB ? "" : hub.slug,
        titles: mappedTitles,
      };
    });
  }, [allContentfulHub, titles]);
};

export const useHub = (hub: string) => {
  const hubs = useHubs();

  return hubs.find(({ slug }) => slug === hub);
};

export default useHubs;
